;(function() {
  'use strict'

  Controller.$inject = ["mediaView"];
  angular.module('app.survey').component('surveyQuestionConstantSumMatrix', {
    controller: Controller,
    templateUrl: 'survey-question-constant-sum-matrix.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller(mediaView) {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.onChange = onChange
    ctrl.onBlur = onBlur

    ctrl.setTableElem = setTableElem
    ctrl.isMobile = isMobile
    ctrl.isChoiceLabel = isChoiceLabel
    ctrl.toggleAccordionStatementId = toggleAccordionStatementId
    ctrl.getSelectedText = getSelectedText
    ctrl.expanderHeight = expanderHeight
    ctrl.expandImage = expandImage

    function onInit() {
      ctrl.question.injectConstantSumPipesValue()
      ctrl.statements = ctrl.question.getVisibleStatements()
      ctrl.choices = ctrl.question.getVisibleChoices()

      // prepare table data
      if (ctrl.question.flipTableAxis) {
        ctrl.tableChoices = _.map(ctrl.statements, function(statement) {
          statement.option = statement.statement
          return statement
        })
        ctrl.tableStatements = _.map(ctrl.choices, function(choice) {
          choice.statement = choice.option
          return choice
        })
        ctrl.hasChoiceImages = ctrl.question.hasStatementImages
        ctrl.hasStatementImages = ctrl.question.hasChoiceImages
        ctrl.isChoiceImageAndLabel = ctrl.question.isStatementImageAndLabel
        ctrl.isStatementImageAndLabel = ctrl.question.isChoiceImageAndLabel
      } else {
        ctrl.tableChoices = ctrl.choices
        ctrl.tableStatements = ctrl.statements
        ctrl.hasChoiceImages = ctrl.question.hasChoiceImages
        ctrl.hasStatementImages = ctrl.question.hasStatementImages
        ctrl.isChoiceImageAndLabel = ctrl.question.isChoiceImageAndLabel
        ctrl.isStatementImageAndLabel = ctrl.question.isStatementImageAndLabel
      }

      var firstStatement = ctrl.statements[0]
      if (firstStatement) {
        ctrl.accordionStatementId = firstStatement.id
      }

      ctrl.numbers = {} // entered numbers model
      _.each(ctrl.statements, function(statement) {
        ctrl.numbers[statement.id] = {}
        _.each(ctrl.choices, function(choice) {
          var choiceNumber = ctrl.question.getSelectedNumber(choice, statement)
          ctrl.numbers[statement.id][choice.id] = choiceNumber
        })
      })

      ctrl.prefix = ctrl.survey.injectValues(
        ctrl.question.textPrefixPipes,
        ctrl.question.loopKey
      )
      ctrl.suffix = ctrl.survey.injectValues(
        ctrl.question.textSuffixPipes,
        ctrl.question.loopKey
      )
    }

    function onChange(number, choice, statement) {
      if (ctrl.question.flipTableAxis && !isMobile()) {
        ctrl.question.setSelectedNumber(number, statement, choice)
      } else {
        ctrl.question.setSelectedNumber(number, choice, statement)
      }
    }

    function onBlur(number, choice, statement) {
      if (!_.isNumber(number)) return // skip
      number = ctrl.question.clampNumber(number)
      if (ctrl.question.flipTableAxis && !isMobile()) {
        ctrl.numbers[choice.id][statement.id] = number
      } else {
        ctrl.numbers[statement.id][choice.id] = number
      }
      onChange(number, choice, statement)
    }

    function setTableElem() {
      ctrl.tableElem = document.getElementsByClassName(
        'survey-question-constant-sum-matrix__table'
      )[0]
    }

    function isMobile() {
      var mobile = ctrl.tableElem.offsetWidth > document.body.offsetWidth
      return mobile
    }

    function isChoiceLabel(choice, asStatement) {
      var isLabelsHidden = asStatement
        ? ctrl.question.statementLabelsHidden
        : ctrl.question.choiceLabelsHidden
      return !isLabelsHidden || !choice.data.imageUrl
    }

    function toggleAccordionStatementId(statementId) {
      if (ctrl.accordionStatementId === statementId) {
        ctrl.accordionStatementId = null
      } else {
        ctrl.accordionStatementId = statementId
      }
    }

    function getSelectedText(statementId) {
      var selected = ctrl.question.statementAnswers[statementId]
      return (
        _.filter(ctrl.choices, function(choice) {
          return !!_.find(selected, { id: choice.id })
        })
          .map(function(choice) {
            var choiceNumber = ctrl.numbers[statementId][choice.id]
            return choice.option + ':' + choiceNumber
          })
          .join(', ') + ' '
      )
    }

    function expanderHeight() {
      return (
        document.getElementsByClassName(
          'survey-question-constant-sum-matrix__accordion-choices'
        )[0].offsetHeight + 'px'
      )
    }

    function expandImage(event, imageUrl) {
      event.preventDefault()
      event.stopPropagation()
      mediaView.showImage(imageUrl)
    }
  }
})()
